import { ECOSYSTEM_PRODUCTS } from "@/config/kingbullish";
import { EcosystemCard } from "@/components/EcosystemCard";
import { SectionHeading } from "@/components/SectionHeading";

export const EcosystemSection = () => (
  <section id="ecosystem" className="section relative overflow-hidden" data-testid="ecosystem-section">
    <div className="container-x relative">
      <SectionHeading
        title="ECOSYSTEM"
        accent="PRODUCTS"
        testId="ecosystem-heading"
        right={
          <p className="font-display text-base font-semibold tracking-wide text-white/80 md:text-lg" data-testid="ecosystem-subtitle">
            REAL PRODUCTS. REAL UTILITY. <span className="text-neon">A BRIGHTER TOMORROW.</span>
          </p>
        }
      />
      <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-4" data-testid="ecosystem-grid">
        {ECOSYSTEM_PRODUCTS.map((p, i) => <EcosystemCard key={p.id} product={p} index={i} />)}
      </div>
    </div>
  </section>
);
